export default "__VITE_ASSET__BlvmRToA__"